"use strict";

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");

var _interopRequireWildcard = require("@babel/runtime/helpers/interopRequireWildcard");

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.validationSchema = void 0;

var yup = _interopRequireWildcard(require("yup"));

var _i18next = _interopRequireDefault(require("i18next"));

var validationSchema = yup.object().shape({
  name: yup.string().required(_i18next["default"].t('stripe.error.name')),
  postalCode: yup.string().required(_i18next["default"].t('stripe.error.postalCode')),
  cardNumber: yup.mixed().required(_i18next["default"].t('stripe.error.cardNumber')),
  cvc: yup.mixed().required(_i18next["default"].t('stripe.error.cvc')),
  expiry: yup.mixed().required(_i18next["default"].t('stripe.error.expiry'))
});
exports.validationSchema = validationSchema;
//# sourceMappingURL=utils.js.map